import { Component, OnInit, SecurityContext } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LookupService } from '../../../../shared/services/lookup.service';
import { LookUp } from '../../../../shared/models/look-up.model';
import { Languages } from '../../../../../shared/models/enums.model';
import { GlobalServices } from '../../../../../shared/services/global.service';
import { SupplierBidSubsriptionService } from '../../../../../shared/services/supplierBidSubsription.service';
import { SupplierBidSubscriptionDto } from '../../../../../shared/models/supplier-bid-subsription.model';
import { ResponseObject } from '../../../../../shared/models/response-object.model';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';


@Component({
  selector: 'app-supplier-bid-subsription',
  templateUrl: './supplier-bid-subsription.component.html',
  styleUrls: ['./supplier-bid-subsription.component.css']
})
export class SupplierBidSubsriptionComponent implements OnInit {
  BidSubscriptionForm:FormGroup;
  supplierBidSubsriptionTypes: LookUp[];
  displayedLang:string;
  model:SupplierBidSubscriptionDto;
  responseObj:ResponseObject;
  numberRegex: string = '^[0-9]*$';
  submitted=false;
  showRequest=true;
  regexpNumber: RegExp = new RegExp('^(?!.*[<])');





  constructor(private formBuilder: FormBuilder, private supplierBidSubscriptionSrv:SupplierBidSubsriptionService,private lookupService: LookupService ,private globalSrv:GlobalServices) {
    this.displayedLang =this.globalSrv.getLanguage() == Languages.Arabic?'NameAR':'NameEN';

  }

  ngOnInit() {
    this.buildForm();
    this.loadLookups();
  }
  loadLookups(){

    this.lookupService.getSupplierBidSubsriptionTypes().subscribe(d => {
      this.supplierBidSubsriptionTypes = d.Data;

    })
  }
  buildForm(){
    this.BidSubscriptionForm=this.formBuilder.group({
    SupplierBidSubsriptionTypeId:[null,[Validators.required]],
    SupplierName:['',[Validators.required, Validators.maxLength(50), CustomValidators.textSpaceValidator(),Validators.pattern(this.regexpNumber)]],
    SupplierEmail:['',Validators.email],
    SupplierFax:['',[Validators.required,Validators.pattern(this.numberRegex)]],
    SupplierPhone:['',[Validators.required]],
    SupplierAddress:['',[Validators.required,Validators.maxLength(200), CustomValidators.textSpaceValidator(),Validators.pattern(this.regexpNumber)]],

    })
  }
  // convenience getter for easy access to form fields
  get Validate() {
    return this.BidSubscriptionForm.controls;
  }
  onSubmit(){

    this.submitted = true;
    if (this.BidSubscriptionForm.invalid || this.BidSubscriptionForm.controls.SupplierBidSubsriptionTypeId.value == "null" ) {
      return;
    }
    this.model = this.BidSubscriptionForm.getRawValue();
    this.model.SupplierPhone=this.BidSubscriptionForm.controls.SupplierPhone.value;
    this.globalSrv.isLoaderEnabled = true;
    this.supplierBidSubscriptionSrv.AddSupplierBidSubscription(this.model).subscribe(
      (data: ResponseObject) => {

        this.responseObj = data;
        if (this.responseObj.Success) {
          let message: string;
          this.BidSubscriptionForm.reset();
          this.showRequest = false;
          this.globalSrv.isLoaderEnabled = false;

        }
    })
  }
}
